module.exports = __webpack_public_path__ + "img/split-order-checkbox-on.2e0b301a.svg";